import React, {useEffect} from 'react';
import PropTypes from 'prop-types';
import {BrowserRouter as Router, Route, Switch} from "react-router-dom";
import resolveLocaleFromUrl from "./actions/resolveLocaleFromUrl";
import resolveThemeFromUrl from "./actions/resolveThemeFromUrl";

import hash from 'object-hash';

import resolveDesignModeFromUrl from "./actions/resolveDesignModeFromUrl";
import processDesignModeMessage from "./actions/processDesignModeMessage";
import Checkout from "./screens/Checkout/Checkout";
import processShopifyModeMessage from "./actions/processShopifyModeMessage";
import resolveCustomSettingsFromUrl from "./actions/resolveCustomSettingsFromUrl";

// If you use React Router, make this component
// render <Router> with your routes. Currently,
// only synchronous routes are hot reloaded, and
// you will see a warning from <Router> on every reload.
// You can ignore this warning. For details, see:
// https://github.com/reactjs/react-router/issues/2182

App.propTypes = {
  store: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};

function App({store, theme}) {

  let themeHash = hash(theme);
  let designModeActive = false;
  let shopifyModeActive = false;

  useEffect(() => {
    store.subscribe(() => {
      let themeStoreState = store.getState().theme;
      if (themeStoreState.hash !== themeHash) {
        themeHash = themeStoreState.hash;
      }

      let designModeStoreState = store.getState().designMode;
      if (designModeStoreState.designMode && !designModeActive) {
        // Initialize design mode changes listener
        window.addEventListener('message', (event) => {
          processDesignModeMessage(event.data, store);
        });
        designModeActive = true;
      }

      let shopifyModeStoreState = store.getState().shopifyMode;
      if (shopifyModeStoreState.shopifyMode && !shopifyModeActive) {
        // Initialize shopify mode changes listener
        window.addEventListener('message', (event) => {
          processShopifyModeMessage(event.data, store);
        }, false);
        shopifyModeActive = true;
      }
    });

    resolveLocaleFromUrl(store);
    resolveThemeFromUrl(store);
    resolveDesignModeFromUrl(store);
    resolveCustomSettingsFromUrl(store);
  }, []);

  return (
      <Router>
        <Switch>
          <Route path={[
            "/gift-card/:programId/:action?/:cardNumber?",
            "/gift-card/:programId/:action?",
            "/gift-card/:programId",
            "/card-checkout/:programId/:action?/:cardNumber?",
            "/card-checkout/:programId/:action?",
            "/card-checkout/:programId",
            "/:programId/:action?/:cardNumber?",
            "/:programId/:action?",
            "/:programId"
          ]} component={Checkout}/>
          {/*<Redirect from="*" to="/"/>*/}
        </Switch>

      </Router>
  );

}

export default App;
